import { useCallback, useContext } from 'react';
import type { WorkspaceFileUpload } from '@trinity/chat';
import { TagGeneratingFilesContext } from '../Workspace/context';
import { FileUploadsDispatchContext } from './Context';
import { BaseFileUploadEffectsContainer } from './Effects.Base.Container';

type Props = {
  children: React.ReactNode;
};

export const FileUploadEffectsContainer = (props: Props) => {

  const dispatch = useContext(FileUploadsDispatchContext);
  const tagGeneratingContext = useContext(TagGeneratingFilesContext);

  const handleComplete = useCallback((fileUpload: WorkspaceFileUpload) => {
    dispatch({
      type: 'update-valid-upload',
      fileUpload,
    });

    // Add file to generating state for tag animation
    if (tagGeneratingContext && fileUpload.fileId) {
      tagGeneratingContext.addGeneratingFiles([fileUpload.fileId]);
    }
  }, [dispatch, tagGeneratingContext]);

  const handleAbort = useCallback((fileUpload: WorkspaceFileUpload) => {
    dispatch({
      type: 'update-valid-upload',
      fileUpload,
    });
  }, [dispatch]);

  const handleFailure = useCallback((fileUpload: WorkspaceFileUpload) => {
    dispatch({
      type: 'update-valid-upload',
      fileUpload,
    });
  }, [dispatch]);

  const handleStart = useCallback((fileUpload: WorkspaceFileUpload) => {
    dispatch({
      type: 'update-valid-upload',
      fileUpload,
    });
  }, [dispatch]);

  const handleQueue = useCallback((fileUpload: WorkspaceFileUpload) => {
    dispatch({
      type: 'add-valid-upload',
      fileUpload,
    });
  }, [dispatch]);

  return (
    <BaseFileUploadEffectsContainer
      onAbort={handleAbort}
      onComplete={handleComplete}
      onFailure={handleFailure}
      onStart={handleStart}
      onQueue={handleQueue}>
      {props.children}
    </BaseFileUploadEffectsContainer>
  );
};